<form [formGroup]="accountForm" novalidate>
  <div class="modal-header">
    <h1>{{ title }}</h1>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger alert-dismissable" *ngIf="errorMsg">
      {{ errorMsg }}
      <a (click)="clearErrorMessage()">
        <span class="float-right close-button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </span>
      </a>
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label>Account Type <span style="color: red">*</span></label>
        <span class="mb-1">(Required)</span>
      </div>
      <select class="form-control" formControlName="accountType">
        <option value="REWARD">Reward</option>
      </select>
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label>Reward Type <span style="color: red">*</span></label>
        <span class="mb-1">(Required)</span>
      </div>
      <select [compareWith]="compareById" class="form-control" formControlName="rewardType">
        <option *ngFor="let type of rewardTypes" [ngValue]="type">{{ type.name }}</option>
      </select>
    </div>
    <div class="form-group">
      <div class="d-flex justify-content-between">
        <label>Status <span style="color: red">*</span></label>
        <span class="mb-1">(Required)</span>
      </div>
      <select class="form-control" formControlName="status">
        <option *ngFor="let option of statuses" value="{{ option }}">{{ option }}</option>
      </select>
    </div>

    <div class="modal-footer">
      <app-modal-buttons (ok)="ok()" (cancel)="cancel()" [submitDisabled]="!accountForm.valid"></app-modal-buttons>
    </div>
  </div>
</form>
